module.exports = __webpack_public_path__ + "static/media/Spapshoot.ff950490.mp4";